import { api } from "..";

const endpoint = "/api/scheduled-payments";

export const getScheduledPaymentList = (queryParams) => {
  return api.get(`${endpoint}`, { params: queryParams });
};

export const getScheduledPaymentById = (id) => {
  return api.get(`${endpoint}/${id}`);
};

export const createScheduledPayment = (data) => {
  return api.post(`${endpoint}`, data);
};

export const updateScheduledPayment = (id, data) => {
  return api.put(`${endpoint}/${id}`, data);
};

export const deleteScheduledPayment = (id) => {
  return api.delete(`${endpoint}/${id}`);
};

// Schedule every due, unlinked RaPayment installment for a company on a single date,
// grouped into one ScheduledPayment run per (Provider, Currency).
export const scheduleFromReceipts = (data) => {
  return api.post(`${endpoint}/schedule-from-receipts`, data);
};

// Link orphan SpItems to real RaPayment installments: links = [{ spItemId, raPaymentId }, ...]
export const linkSpItems = (scheduledPaymentId, links) => {
  return api.post(`${endpoint}/${scheduledPaymentId}/link-items`, links);
};

// Add a brand-new row to an existing (open) run for an already-existing, unlinked RaPayment
// installment matching the run's Provider/Currency.
export const addRaPaymentToSchedule = (scheduledPaymentId, raPaymentId) => {
  return api.post(`${endpoint}/${scheduledPaymentId}/items`, { raPaymentId });
};

// Remove ("un-schedule") a row from a run. Blocked if the run is locked or the installment
// already has a settled PaymentTx allocation.
export const unscheduleItem = (scheduledPaymentId, spItemId) => {
  return api.delete(`${endpoint}/${scheduledPaymentId}/items/${spItemId}`);
};

export const exportScheduledPaymentLayout = (scheduledPaymentIds) => {
  return api.post(`${endpoint}/export-layout`, scheduledPaymentIds);
};

export const generateScheduledPayments = (scheduledPaymentIds) => {
  return api.post(`${endpoint}/generate-payments`, scheduledPaymentIds);
};
